export class AttendancePlaceFilterModel {
  id: number;
  startMonth: number;
  startYear: number;
  endMonth: number;
  endYear: number;
} 
